import React from 'react';
import { P, Margin } from '@ovotech/element-v4';
import { ModalStepTitle } from '@/src/pages/AnytimeEligibilityV2/pages/PreEligibilityProducts/PreEligibilityProducts.styled';

export const WhatYouGetStep2: React.FC = () => (
  <Margin top={6}>
    <ModalStepTitle>EV charger cover</ModalStepTitle>
    <P>
      Covers you against the costs associated with fire, theft, vandalism,
      accidental damage or operational failure. Applies to all monthly plans.
    </P>
  </Margin>
);
